module.exports = __webpack_public_path__ + "media/intro-landscape.9f46f6d1.mp4";